/* DOMŪS SAVAGE — header: slide-out menu + live cart count. */
(function () {
  'use strict';
  var REDUCED = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  class DsHeader extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.openBtn = this.querySelector('[data-menu-open]');
      this.drawer = this.querySelector('[data-menu]');
      this.countEl = this.querySelector('[data-cart-count]');
      this.bubble = this.querySelector('#cart-icon-bubble');

      if (this.openBtn && this.drawer) {
        this.openBtn.addEventListener('click', function () { self.open(); });
        this.drawer.querySelectorAll('[data-menu-close]').forEach(function (el) {
          el.addEventListener('click', function () { self.close(); });
        });
        this.onKey = function (e) {
          if (e.key === 'Escape') { self.close(); return; }
          if (e.key !== 'Tab') return;
          var f = self.drawer.querySelectorAll('a[href], button');
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        };
      }

      /* The theme's cart page rewrites #cart-icon-bubble after a quantity change; mirror its count. */
      if (this.bubble && this.countEl && window.MutationObserver) {
        this.observer = new MutationObserver(function () {
          var n = self.bubble.querySelector('.cart-count-bubble span[aria-hidden="true"]');
          var text = n ? n.textContent.trim() : '';
          if (self.countEl.textContent !== text) self.countEl.textContent = text;
        });
        this.observer.observe(this.bubble, { childList: true, subtree: true, characterData: true });
      }
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      clearTimeout(this.closeTimer);
      document.removeEventListener('keydown', this.onKey);
      document.documentElement.style.overflow = '';
    }
    open() {
      var self = this;
      clearTimeout(this.closeTimer);
      this.drawer.hidden = false;
      void this.drawer.offsetWidth;                 // let the slide start from off-screen
      this.drawer.classList.add('is-open');
      this.openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKey);
      var close = this.drawer.querySelector('button[data-menu-close]');
      if (close) close.focus();
    }
    close() {
      var self = this;
      if (this.drawer.hidden) return;
      this.drawer.classList.remove('is-open');
      this.openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this.onKey);
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(function () { self.drawer.hidden = true; }, REDUCED ? 0 : 400);
      this.openBtn.focus();
    }
  }
  if (!customElements.get('ds-header')) customElements.define('ds-header', DsHeader);
})();
